var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.227 2.828 13.864 15.13L8.589 4.11c-.23.143-.456.293-.677.45l16.68 13.994L5.688 6.512c-.178.192-.35.39-.517.593L24.172 19.21 3.532 9.587c-.12.23-.232.464-.338.702l20.65 9.628-21.57-6.8c-.053.255-.1.512-.139.772l21.474 6.77L2 16.849c.016.27.04.538.07.804l21.404 3.774-20.758-.907c.091.267.19.531.296.791l20.428.893L4.385 23.87c.17.251.349.496.534.735l18.588-1.626-16.624 3.684c.254.217.516.425.784.624l16.008-3.55-13.636 4.964c.344.162.697.31 1.056.444l12.847-4.676-10.295 5.36c.452.075.91.13 1.376.16l9.278-4.83-6.834 4.786a13.958 13.958 0 0 0 1.797-.308l5.484-3.84L21.254 29a13.975 13.975 0 0 0 2.898-1.6l1.122-1.028-.39.466A13.984 13.984 0 0 0 30 16.01c0-1.368-.196-2.692-.563-3.944l-.177 4.058-.518-5.925a13.962 13.962 0 0 0-.932-1.713l.675 7.704-2.13-9.606a14.12 14.12 0 0 0-1.023-1.014l2.393 10.79L23.23 4.014a14.006 14.006 0 0 0-1.034-.568l4.797 13.18-7.366-14.15a13.92 13.92 0 0 0-.997-.228l7.673 14.738L15.808 2c-.31.004-.617.018-.922.041l10.777 15.392L12.04 2.562c-.275.081-.546.17-.813.266z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfi);
export default __webpack_public_path__ + "static/media/UFI.f6a8795d439fdfa69317c2912b6bf6b2.svg";
export { ForwardRef as ReactComponent };